import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useAcceptInvitationMutation = () => {
  const { teamController } = useAvApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['accept-team-invitation'],
    mutationFn: async (invitationId: string) => {
      const response =
        await teamController.postV2TeamsInviteAcceptPanelByInvitationId(null, {
          invitationId,
        });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['my-invitations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['teams'],
      });
      queryClient.invalidateQueries({
        queryKey: ['projects'],
      });
    },
  });
};
